import React, { useCallback } from 'react';

import OnboardingWizardContentWrapper from '../OnboardingWizardWrappers/OnboardingWizardContentWrapper/OnboardingWizardContentWrapper';
import DiscussionTopicsEmptyState from '../DiscussionTopics/DiscussionTopicsListPreview/DiscussionTopicsEmptyState/DiscussionTopicsEmptyState';
import WorkspacesPreview from '../WorkspacesPreview/WorkspacesPreview';
import { WorkspacesType } from '../../types';
import RecurringMeetingForm from './RecurringMeetingForm/RecurringMeetingForm';
import ManualWorkspacesForm from './ManualWorkspacesForm/ManualWorkspacesForm';
import WorkspaceAddMoreButton from './WorkspaceAddMoreButton/WorkspaceAddMoreButton';

import './WorkspacesFromCalendar.scss';

type Props = {
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
};

function WorkspacesFromCalendar({ workspaces: initWorkspaces, advanceOnboardingState }: Props) {
  const handleSubmit = useCallback(
    ({ workspaces, numDirectReports }) => {
      return advanceOnboardingState({
        workspaces: workspaces.filter(({ uuid, fullName }) => uuid && fullName),
        num_direct_reports: numDirectReports,
      });
    },
    [advanceOnboardingState]
  );

  const formValidate = useCallback(values => {
    if (values.workspaces && values.workspaces.some(item => item.fullName)) return {};
    return { error: 'Required field' };
  }, []);

  const errorsDisableSubmit = useCallback(errors => {
    if (errors.workspaces) {
      if (errors.workspaces.some(workspace => workspace && Object.keys(workspace).some(k => k !== 'email'))) {
        return true;
      }
    }
    if (Object.keys(errors).some(e => e !== 'workspaces')) return true;
    return false;
  }, []);

  return (
    <OnboardingWizardContentWrapper
      initialValues={{
        workspaces: initWorkspaces.length ? initWorkspaces : [],
      }}
      onNextStep={handleSubmit}
      previewSectionContent={
        <WorkspacesPreview workspaceContent={<DiscussionTopicsEmptyState />} useFirstWorkspaceIfNull />
      }
      formValidate={formValidate}
      errorsDisableSubmit={errorsDisableSubmit}
    >
      <div className="d-flex flex-column onboarding-workspaces">
        <h4 className="padding-right-50">
          Workspaces store the agenda and action items for a meeting. Which 1:1 meetings should we create a workspace
          for?
        </h4>
        <WorkspaceAddMoreButton label="Add 1:1 manually" />
        <div>
          <div className="onboarding-workspaces-from-calendar-fields scrollbar">
            <div className="my-2">
              <ManualWorkspacesForm />
            </div>
            <div className="onboarding-workspaces-from-calendar-fields-label mb-2">Added from Calendar</div>
            <RecurringMeetingForm />
          </div>
        </div>
      </div>
    </OnboardingWizardContentWrapper>
  );
}

export default WorkspacesFromCalendar;
